import { html } from "@microsoft/fast-element";
/**
 * The template for the Fluent Card Header web-component.
 * @public
 */
export function cardHeaderTemplate() {
    return html `
    <template>
      <slot name="start"></slot>
      <div class="image" part="image">
        <slot name="image"></slot>
      </div>
      <div class="header" part="header">
        <div class="row" part="row">
          <slot name="header"></slot>
        </div>
        <div class="row" part="row">
          <slot name="subtitle"></slot>
        </div>
      </div>
      <slot></slot>
      <slot name="action"></slot>
      <slot name="end"></slot>
    </template>
  `;
}
export const template = cardHeaderTemplate();
//# sourceMappingURL=card-header.template.js.map